import { useEffect, useState } from 'react'
import { api, fmtDateTime } from '../lib/api'
import type { AuditRow } from '../lib/api'
import { IconRefresh } from '../components/Icons'

type State =
  | { kind: 'loading' }
  | { kind: 'error'; message: string }
  | { kind: 'ok'; rows: AuditRow[]; lastFetch: number }

const REFRESH_MS = 5000

export function AuditPage() {
  const [state, setState] = useState<State>({ kind: 'loading' })
  const [autoRefresh, setAutoRefresh] = useState(true)

  useEffect(() => {
    let alive = true
    let timer: number | undefined

    const load = async () => {
      const res = await api.audit(200)
      if (!alive) return
      if (!res.ok) setState({ kind: 'error', message: res.error })
      else setState({ kind: 'ok', rows: res.data, lastFetch: Date.now() })
    }

    load()
    if (autoRefresh) {
      timer = window.setInterval(load, REFRESH_MS)
    }
    return () => {
      alive = false
      if (timer) window.clearInterval(timer)
    }
  }, [autoRefresh])

  return (
    <>
      <div className="filter-bar">
        <div className="filter-counter">
          {state.kind === 'ok' && (
            <span><strong>{state.rows.length}</strong> appel{state.rows.length > 1 ? 's' : ''} sortant{state.rows.length > 1 ? 's' : ''}</span>
          )}
        </div>
        <label className="filter-checkbox">
          <input
            type="checkbox"
            checked={autoRefresh}
            onChange={e => setAutoRefresh(e.target.checked)}
          />
          <IconRefresh size={14} />
          <span>Rafraîchissement auto (5 s)</span>
        </label>
      </div>

      {state.kind === 'loading' && <div className="empty-state"><p>Chargement…</p></div>}
      {state.kind === 'error' && (
        <div className="empty-state">
          <h2>Erreur</h2>
          <p>{state.message}</p>
        </div>
      )}
      {state.kind === 'ok' && state.rows.length === 0 && (
        <div className="empty-state">
          <p>Aucun appel sortant enregistré. Chaque appel vers Teogest est loggé ici (méthode, route, statut, durée, mode).</p>
        </div>
      )}
      {state.kind === 'ok' && state.rows.length > 0 && (
        <div className="table-wrap">
          <table className="table-audit">
            <thead>
              <tr>
                <th>Horodatage</th>
                <th>Méthode</th>
                <th>Chemin</th>
                <th>Client</th>
                <th>Statut</th>
                <th>Durée</th>
                <th>Mode</th>
              </tr>
            </thead>
            <tbody>
              {state.rows.map(r => (
                <tr key={r.id} className={r.status && r.status >= 400 ? 'row-error' : ''}>
                  <td className="mono">{fmtDateTime(r.ts)}</td>
                  <td><span className={`chip-method chip-method-${r.method.toLowerCase()}`}>{r.method}</span></td>
                  <td className="mono col-path">{r.path}</td>
                  <td className="mono">{r.code_client ?? '—'}</td>
                  <td className="mono">{r.status ?? '—'}</td>
                  <td className="mono align-right">{r.duration_ms} ms</td>
                  <td>
                    {r.write_mode
                      ? <span className="chip chip-red">WRITE</span>
                      : <span className="chip chip-blue">READ</span>}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </>
  )
}
